import * as React from 'react';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { Input, Alert, Button, Select } from 'antd';
import { connect } from 'react-redux';
import { FormComponentProps } from '@ant-design/compatible/lib/form/Form';
import { withRouter } from 'react-router';
import { supplierFacilitiesRestCrudThunksForSupplier } from '../../thunks/supplier_facilities_thunks';
import { spendCategoriesRestCrudThunksForSupplier } from '../../thunks/spend_categories_thunks';
import { OWLogoUpload } from '../ow_logo_upload/OWLogoUpload';

const style = require('./EditSupplierCoreInfoForm.less');
const FormItem = Form.Item;
interface EditSupplierCoreInfoFormProps extends FormComponentProps {
	loading: boolean;
	displayName: string;
	logoURL: string;
	updateSupplier: any;
	successCallback: any;
	cancelCallback: any;
	supplierFacility: any;

	errors: string[];
}

class EditSupplierCoreInfoForm extends React.Component<EditSupplierCoreInfoFormProps, any> {
	state = {
		logoURL: null,
	};

	componentDidMount() {
		this.setState({ logoURL: this.props.logoURL });
	}

	handleSubmit = (e) => {
		const { updateSupplier, successCallback, supplierFacility, form } = this.props;
		e.preventDefault();
		form.validateFields((err, values) => {
			if (!err) {
				const updatedSupplier = {
					...supplierFacility,
					name: values.displayName,
					displayName: values.displayName,
					logoURL: this.state.logoURL,
				};
				updateSupplier(updatedSupplier)
					.then((resp) => successCallback(resp))
					.catch(() => {});
			}
		});
	};

	render() {
		const { getFieldDecorator } = this.props.form;

		const { loading, errors, cancelCallback, displayName } = this.props;

		const { logoURL } = this.state;

		return (
			<Form layout="vertical" onSubmit={this.handleSubmit} className="editSupplierCoreInfoForm">
				{errors && errors.length > 0
					? errors.map((msg, idx) => (
							<FormItem key={idx}>
								<Alert message={msg} type="error" />
							</FormItem>
					  ))
					: null}
				<FormItem label="What name do your customers call your company?">
					{getFieldDecorator('displayName', {
						rules: [
							{
								required: true,
								message:
									"Please input your company's name as used in advertising and sales materials!",
							},
						],
						initialValue: displayName,
					})(<Input style={{ maxWidth: 500 }} />)}
				</FormItem>
				<FormItem label="Upload your company's logo. Square 300x300 pixel images look best.">
					<OWLogoUpload
						className="avatar-uploader uploader_polyfill_supplierHero"
						imageUrl={logoURL}
						onChange={(url) => this.setState({ logoURL: url })}
					/>
				</FormItem>
				<FormItem>
					<Button type="primary" htmlType="submit" loading={loading}>
						Update supplier info
					</Button>
					<Button style={{ marginLeft: 16 }} onClick={cancelCallback}>
						Cancel
					</Button>
				</FormItem>
			</Form>
		);
	}
}

const mapStateToProps = (state, ownProps) => ({
	loading: state.supplier_facilities.updating,
	errors: state.supplier_facilities.updateErrors,
	spendCategories: state.spend_categories,
	description: ownProps.description,
	successCallback: ownProps.successCallback,
	cancelCallback: ownProps.cancelCallback,
	supplierFacility: ownProps.supplierFacility,
});

const mapDispatchToProps = (dispatch) => ({
	updateSupplier: (supplierFacility) =>
		dispatch(supplierFacilitiesRestCrudThunksForSupplier.update(supplierFacility)),
	fetchSpendCategories: (params, targetCollectionName) =>
		dispatch(spendCategoriesRestCrudThunksForSupplier.read(params, targetCollectionName)),
	fetchMultipleSpendCategories: (ids, targetCollectionName) =>
		dispatch(spendCategoriesRestCrudThunksForSupplier.readMultiple(ids, targetCollectionName)),
});

export default withRouter<any, any>(
	connect(
		mapStateToProps,
		mapDispatchToProps
	)(Form.create<EditSupplierCoreInfoFormProps>()(EditSupplierCoreInfoForm))
);
